<template>
    <div class="c-zn-forms-search">
        <label for="search" class="c-zn-forms-search__label">Waar ben je naar op zoek?</label>
        <div class="c-zn-forms-search__inputwrapper">
            <input class="c-zn-forms-search__input" 
                type="text" 
                :value="modelValue" 
                id="search" 
                placeholder="Zoeken naar..." 
                @input="$emit('update:modelValue', $event.target.value)"
            >
            <svg class="icon icon-icon_search"><use xlink:href="#icon-icon_search"></use></svg>
        </div>
    </div>
</template>

<script>
export default {
    props: ['modelValue'],
    emits: ['update:modelValue']
}
</script>